import { cva } from "class-variance-authority"

export const layoutSlideOutRoot = cva(["relative", "flex", "grow", "h-full", "overflow-hidden"])

export const layoutSlideOutContent = cva(
	[
		"relative",
		"overflow-hidden",
		"bg-(--color-background)",
		"dark:bg-(--base-2)",
		"border-(--base-6)",
		"h-full",
		"shrink-0",
	],
	{
		variants: {
			side: {
				left: ["border-r-1", "top-0", "bottom-0"],
				right: ["border-l-1", "top-0", "bottom-0"],
				top: ["border-b-1", "left-0", "right-0"],
				bottom: ["border-t-1", "left-0", "right-0"],
			},
		},
	},
)

export const layoutSlideOutOverlay = cva(["absolute", "inset-0", "light:bg-(--black-a6)", "dark:bg-(--black-a8)"])

export const layoutSlideOutViewport = cva(["relative", "flex", "grow", "h-full", "overflow-hidden", "shrink-1"])

export const layoutSlideOutHandle = cva(
	["absolute", "hover:bg-(--base-indicator)", "data-[resizing=true]:bg-(--base-indicator)", "transition-colors"],
	{
		variants: {
			side: {
				left: ["right-0", "cursor-ew-resize", "top-0", "bottom-0", "w-0.5"],
				right: ["left-0", "cursor-ew-resize", "top-0", "bottom-0", "w-0.5"],
				top: ["bottom-0", "cursor-nw-resize", "left-0", "right-0", "h-0.5"],
				bottom: ["top-0", "cursor-nw-resize", "left-0", "right-0", "h-0.5"],
			},
		},
	},
)
